import { useEffect, useState} from "react";
import { useMutualCBO } from "../../Services/MutualPaciente";

export const useMutualMesesAnteriores = () => {
  const { getMutualFecha } = useMutualCBO();

  const [PrestacionAnterior, setPrestacionAnterior] = useState([]);
  const [errorPrestacionAnterior, setErrorPrestacionAnterior] = useState(null);
  const [loadingPrestacionAnterior, setLoadingPrestacionAnterior] = useState(true);

  const fetchGetPrestacionGeneralAnterior = async (params = null) => {
    setLoadingPrestacionAnterior(true);

    try {
      const today = new Date();

      const defaultParams = {
        mes: today.getMonth() + 1,
        anio: today.getFullYear()
      };

      const data = await getMutualFecha(params || defaultParams);

      setPrestacionAnterior(data);
      setErrorPrestacionAnterior(null);

    } catch (error) {
      setErrorPrestacionAnterior(error);
    } finally {
      setLoadingPrestacionAnterior(false);
    }
  };

  useEffect(() => {
    fetchGetPrestacionGeneralAnterior();
  }, []);

  return {
    PrestacionAnterior,
    errorPrestacionAnterior,
    loadingPrestacionAnterior,
    refetchPrestacionAnterior: fetchGetPrestacionGeneralAnterior,
  };
};


export const useMutualEstados = () => {
  const { getMutualEstado } = useMutualCBO();

  const [mutualEstado, setMutualEstado] = useState([]);
  const [errorMutualEstado, setErrorMutualEstado] = useState(null);
  const [loadingMutualEstado, setLoadingMutualEstado] = useState(true);

  const fetchGetMutualEstado = async () => {
    setLoadingMutualEstado(true);
    try {
      const data = await getMutualEstado();
      setMutualEstado(data);
      setErrorMutualEstado(null);
    } catch (error) {
      setErrorMutualEstado(error);
    } finally {
      setLoadingMutualEstado(false);
    }
  };

 
  useEffect(() => {
    fetchGetMutualEstado();
  }, []);

  return {
    mutualEstado,
    errorMutualEstado,
    loadingMutualEstado,
    refetchMutualEstado: fetchGetMutualEstado,
  };
}
